export const recentPurchases = [
  { name: 'Mariana', city: 'Buenos Aires', country: 'Argentina', flag: '🇦🇷', minutesAgo: 2 },
  { name: 'Carlos', city: 'Ciudad de México', country: 'México', flag: '🇲🇽', minutesAgo: 4 },
  { name: 'Valentina', city: 'Santiago', country: 'Chile', flag: '🇨🇱', minutesAgo: 6 },
  { name: 'Andrés', city: 'Bogotá', country: 'Colombia', flag: '🇨🇴', minutesAgo: 3 },
  { name: 'Lucía', city: 'Lima', country: 'Perú', flag: '🇵🇪', minutesAgo: 8 },
  { name: 'Sofía', city: 'Montevideo', country: 'Uruguay', flag: '🇺🇾', minutesAgo: 5 },
  { name: 'Jessica', city: 'Miami', country: 'Estados Unidos', flag: '🇺🇸', minutesAgo: 7 },
  { name: 'Gabriela', city: 'Quito', country: 'Ecuador', flag: '🇪🇨', minutesAgo: 9 },
  { name: 'Diego', city: 'Córdoba', country: 'Argentina', flag: '🇦🇷', minutesAgo: 1 },
  { name: 'Camila', city: 'São Paulo', country: 'Brasil', flag: '🇧🇷', minutesAgo: 11 },
  { name: 'Fernanda', city: 'Guadalajara', country: 'México', flag: '🇲🇽', minutesAgo: 3 },
  { name: 'Paula', city: 'Asunción', country: 'Paraguay', flag: '🇵🇾', minutesAgo: 12 },
  { name: 'Daniela', city: 'Caracas', country: 'Venezuela', flag: '🇻🇪', minutesAgo: 6 },
  { name: 'María José', city: 'San José', country: 'Costa Rica', flag: '🇨🇷', minutesAgo: 4 },
  { name: 'Laura', city: 'Santo Domingo', country: 'Rep. Dominicana', flag: '🇩🇴', minutesAgo: 10 },
  { name: 'Natalia', city: 'La Paz', country: 'Bolivia', flag: '🇧🇴', minutesAgo: 7 },
  { name: 'Ana', city: 'Panamá', country: 'Panamá', flag: '🇵🇦', minutesAgo: 2 },
  { name: 'Romina', city: 'Rosario', country: 'Argentina', flag: '🇦🇷', minutesAgo: 5 },
]
